import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
// Types
import mixins from "vue-typed-mixins"; // Should be part of EditorBase
// Mixins
import EditorBase from '../../mixins/EditorBase';
import { GboxMediaModalEvents } from '../modals/GboxMedia';
import { WithRefs } from '../../utils/withRefs';

// Enums
import { Modals } from '../../enums/Modals';
import CmsAltMenu from '../ui/CmsAltMenu';
const EditorImage = mixins(EditorBase(() => null), GboxMediaModalEvents, WithRefs()).extend({
  name: 'EditorImage',
  props: {
    mediaCount: {
      type: Number,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disableEditButton: {
      type: Boolean,
      default: false
    },
    buttonClass: {
      type: String,
      default: ''
    },
    imageClass: {
      type: String,
      default: ''
    },
    inBackground: {
      type: Boolean,
      default: false
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    hideControls: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    }
  },
  computed: {
    isVideo() {
      var _this$computedValue, _this$computedValue$m;
      return !!((_this$computedValue = this.computedValue) !== null && _this$computedValue !== void 0 && (_this$computedValue$m = _this$computedValue.mime) !== null && _this$computedValue$m !== void 0 && _this$computedValue$m.includes('video'));
    }
  },
  methods: {
    focus() {
      var _this$$refs$selectBut;
      (_this$$refs$selectBut = this.$refs.selectButton) === null || _this$$refs$selectBut === void 0 ? void 0 : _this$$refs$selectBut.focus(); // todo: isn't working
    },

    async openMediaModal(forPosterImage = false) {
      const recommendedSizes = await this.getRecommendedSizes();
      this.$modal.show(Modals.Media, {
        recommendedSizes,
        size: this.size,
        onConfirm: media => forPosterImage ? this.computedValue && (this.computedValue = {
          ...this.computedValue,
          poster: media
        }) : this.computedValue = {
          ...media,
          poster: null
        }
      });
      this.$modal.subscription.$on('toggle', this.handleSubscriptionListener);
    },
    async getRecommendedSizes() {
      const {
        width = 0,
        height = 0
      } = this.getSize();
      const {
        mediaSizes
      } = this.$application.storage;
      if (!(mediaSizes !== null && mediaSizes !== void 0 && mediaSizes.length)) {
        await this.$application.fetchMediaSizes();
      }
      const mediaSizesWithParsedXandY = (mediaSizes === null || mediaSizes === void 0 ? void 0 : mediaSizes.map(size => ({
        ...size,
        x: Number(size.x),
        y: Number(size.y)
      }))) || [];
      const sizesLargerThanImageElement = mediaSizesWithParsedXandY.filter(size => size.x >= width && size.y >= height);
      const smallestX = Math.min(...sizesLargerThanImageElement.map(size => size.x));
      const filteredBySmallestX = sizesLargerThanImageElement.filter(size => size.x === smallestX);
      const smallestY = Math.min(...filteredBySmallestX.map(size => size.y));
      const filteredBySmallestXandY = filteredBySmallestX.filter(size => size.y === smallestY);
      const filteredSizesWithStringXandY = filteredBySmallestXandY.map(size => ({
        ...size,
        x: size.x.toString(),
        y: size.y.toString()
      }));
      return filteredSizesWithStringXandY;
    },
    getSize() {
      if (this.size) {
        const [width, height] = this.size.split('x').map(size => +size.trim() || 0);
        return {
          width,
          height
        };
      } else {
        var _this$$refs$cmsImage;
        const {
          width = 0,
          height = 0
        } = ((_this$$refs$cmsImage = this.$refs.cmsImage) === null || _this$$refs$cmsImage === void 0 ? void 0 : _this$$refs$cmsImage.getBoundingClientRect()) || {};
        return {
          width,
          height
        };
      }
    },
    handleSubscriptionListener(name, value) {
      if (name === 'gbox-media' && !value) {
        var _this$$refs$selectBut2;
        (_this$$refs$selectBut2 = this.$refs.selectButton) === null || _this$$refs$selectBut2 === void 0 ? void 0 : _this$$refs$selectBut2.focus();
        this.$modal.subscription.$off('toggle', this.handleSubscriptionListener);
      }
    }
  },
  render() {
    var _this$$scopedSlots$de, _this$$scopedSlots;
    const h = arguments[0];
    const {
      width = 0,
      height = 0
    } = this.getSize();
    const imageSlot = this.$slots.image || this.inBackground && ((_this$$scopedSlots$de = (_this$$scopedSlots = this.$scopedSlots).default) === null || _this$$scopedSlots$de === void 0 ? void 0 : _this$$scopedSlots$de.call(_this$$scopedSlots, {})) || (this.computedValue ? h("cms-image", {
      "attrs": {
        "autoplay": this.autoplay,
        "controls": !this.hideControls,
        "media": this.computedValue,
        "width": width || '',
        "height": height || ''
      },
      "class": [this.imageClass, this.inBackground && !this.isVideo ? 'invisible' : '']
    }) : this.$isInEditMode ? h("div", {
      "class": "h-24 flex items-center justify-center text-center"
    }, [this.$at('core.input.noImageSelected'), h("br"), this.size]) : undefined);
    const imageURL = this.$cmsMedia({
      media: this.computedValue
    });
    // From 0.107.0, $cmsMedia can also return array of strings which means that there are alternative links to different file formats if user selected 'default' compression
    // where array indices will correspond to formats: 0:.avif, 1:.webp, 2:.jpeg, 3:.png
    // Safari doesnt work with avif, so in case of using in-background prop with applied compression 'default', we will always use the .webp one

    const computedURL = Array.isArray(imageURL) && imageURL.length ? imageURL.find(uri => uri.endsWith('.webp')) || '' : imageURL;
    return this.$isInEditMode && !this.disableEditButton ? h("div", {
      "ref": 'cmsImage',
      "class": "relative",
      "style": {
        backgroundImage: this.inBackground && !this.isVideo && this.computedValue ? `url(${computedURL})` : undefined
      }
    }, [h(CmsAltMenu, {
      "attrs": {
        "disabled": !this.computedValue,
        "closeOnContentClick": true
      },
      "scopedSlots": {
        opener: () => h("button", _mergeJSXProps([{
          "ref": "selectButton",
          "attrs": {
            "type": "button"
          }
        }, {
          directives: [{
            name: 'tooltip',
            value: {
              classes: 'px-2 py-1 shadow-md rounded-sm bg-white z-core-menu',
              content: this.$at('core.action.selectImage')
            },
            modifiers: {
              right: true
            }
          }]
        }, {
          "class": ['absolute top-0 right-0 bg-white rounded-tr-sm p-1 h-8 w-8 z-10', this.buttonClass],
          "on": {
            "click": () => !this.computedValue && this.openMediaModal()
          }
        }]), [h("em", {
          "class": "core-icon-photo-video"
        })]),
        default: () => h("ul", {
          "attrs": {
            "id": this.$attrs.id ? this.$attrs.id + '-menu' : ''
          },
          "class": 'bg-white rounded-md shadow-lg border border-gray-300'
        }, [h("li", {
          "class": 'rounded-t-md cursor-pointer h-12 flex items-center hover:bg-blue-100 transition-colors duration-150 px-4 whitespace-no-wrap',
          "on": {
            "click": () => this.openMediaModal()
          }
        }, [this.$at('core.action.changeSelection')]), this.isVideo && h("li", {
          "class": 'cursor-pointer h-12 flex items-center hover:bg-blue-100 transition-colors duration-150 px-4 whitespace-no-wrap',
          "on": {
            "click": () => this.openMediaModal(true)
          }
        }, [this.$at('core.action.changeCoverImage')]), h("li", {
          "class": 'rounded-b-md cursor-pointer h-12 flex items-center hover:bg-blue-100 transition-colors duration-150 px-4 whitespace-no-wrap bg-red-100 text-red-700',
          "on": {
            "click": () => this.computedValue = null
          }
        }, [this.$at('core.action.removeSelection')])])
      }
    }), this.mediaCount && this.multiple && h("button", _mergeJSXProps2([{
      "attrs": {
        "type": "button"
      }
    }, {
      directives: [{
        name: 'tooltip',
        value: 'Number of selected images',
        modifiers: {
          right: true
        }
      }]
    }, {
      "class": "section-button section-button--count"
    }]), [this.mediaCount]), imageSlot]) : h("div", {
      "ref": 'cmsImage',
      "class": "relative",
      "style": {
        backgroundImage: this.inBackground && !this.isVideo && this.computedValue ? `url(${computedURL})` : undefined
      }
    }, [imageSlot]);
  }
});
export default EditorImage;